import { AllTicketsContents } from "../components/ticketing-allticket-content";
import { TicketingHead } from "../components/ticketing-head";

export function AllTickets() {
  return (
    <>
      <TicketingHead
        TicketingBreadCrumbsProps={{
          home: {
            title: "Home",
            url: "/admin/svr/dashboard",
          },
          className: "lg:h-[200px]",
          pageTitles: [{ name: "Dashboard", url: "/admin/svr/dashboard" }],
        }}
      />

      <div className="p-4">
        <AllTicketsContents />
      </div>
    </>
  );
}
